import { Type } from "class-transformer";
import { UserDto } from "@/core/features/users/user.dto";

export class PlanningBoardUserAssignmentDto {
  @Type(() => UserDto)
  user: UserDto;

  daysMask: number;
}
